<template>
    <div>
        <div class="col-md-12" v-if="claims.tasks.create">
            <button class="btn btn-primary" @click="showCreate = true" data-toggle="modal" data-target="#createTaskModal">
                {{ $t('tasks.newTask') }}
            </button>
        </div>
        <tabs
            :options="{ useUrlFragment: false, loadSavedTab: false }" cache-lifetime="10"
            class="m-0"
        >
            <tab id="assignedToMeTab" :name="$t('tasks.assignedToMe')">
                <div class="col-md-12 py-1" v-if="showAssignedToMeSettings">
                    <i class="fas fa-cogs pointer fa-2x text-success float-right"
                        @click.stop="changeGridSettings('assignedToMeGrid')"
                        data-toggle="tooltip"
                        :title="$t('buttons.settings.tooltipText')"></i>
                    <GridUserSettings ref="assignedToMeSettings"
                                        :visible="showAssignedToMeSettingsForm"
                                        :grid="$refs['assignedToMeGrid']"
                                        :componentName="'assignedToMeGrid'">
                    </GridUserSettings>
                    <div style="clear: both;"></div>
                </div>
                <div class="grid-wrapper">
                    <kendo-datasource ref="datasource2"
                        :transport="transportSettings"
                        :schema-model-id="'id'"
                        :schema-total="'total'"
                        :schema-data="'data'"
                        :page-size="defaultGridRows"
                        :server-paging="true"
                        :server-sorting="true"
                        :server-filtering="true"
                        :change="onChange" />
                    <kendo-grid ref="assignedToMeGrid"
                        :data-source-ref="'datasource2'"
                        :dataBound="onDatabound"
                        :editable="gridOptions.editable"
                        :filterable="gridOptions.filterable"
                        :pageable="gridOptions.pageable"
                        :reorderable="gridOptions.reorderable"
                        :resizable="gridOptions.resizable"
                        :groupable="gridOptions.groupable"
                        :allow-copy="gridOptions.allowCopy"
                        :column-menu="gridOptions.columnMenu"
                        :sortable-mode="gridOptions.sortable.mode"
                        :sortable-allow-unsort="gridOptions.sortable.allowUnsort"
                        :sortable-show-indexes="gridOptions.sortable.showIndexes"
                        :selectable="gridOptions.selectable"
                        :scrollable="gridOptions.scrollable"
                        name="assignedToMeGrid">
                        <!-- <kendo-grid-column :field="'id'" :filterable="false" :title="$t('registers.forms.gridHeaders.id')" :width="100" :lockable="true" :locked="false"></kendo-grid-column> -->
                        <kendo-grid-column :field="'id'" :title="'Id'" :width="100" :lockable="true"
                                            :locked="false"></kendo-grid-column>
                        <kendo-grid-column :field="'title'" :title="$t('tasks.title')" :width="200"
                                            :lockable="true" :locked="false"></kendo-grid-column>
                        <!-- <kendo-grid-column :field="'createdOn'" :title="$t('tasks.assignedOn')" :width="200" :lockable="true" :locked="false" :format="'{0:dd.MM.yyyy}'"></kendo-grid-column>-->
                        <kendo-grid-column :field="'assigner'" :title="$t('tasks.assigner')" :width="200"
                                            :lockable="true" :locked="false"></kendo-grid-column>
                        <kendo-grid-column :field="'deadline'" :title="$t('tasks.deadline')" :width="200"
                                            :lockable="true" :locked="false"
                                            :format="'{0:dd.MM.yyyy H:mm}'"></kendo-grid-column>
                        <!-- <kendo-grid-column :field="'type'" :title="$t('tasks.type')" :width="200" :lockable="true" :locked="false"></kendo-grid-column>-->
                        <kendo-grid-column :field="'priority'" :title="$t('tasks.priority')" :width="200"
                                            :lockable="true" :locked="false"></kendo-grid-column>
                        <kendo-grid-column :field="'category'" :title="$t('tasks.category')" :width="200"
                                            :lockable="true" :locked="false"></kendo-grid-column>
                        <kendo-grid-column :field="'status'" :title="$t('tasks.status')" :width="200"
                                            :lockable="true" :locked="false"></kendo-grid-column>
                        <kendo-grid-column :title="$t('actions')" :template="assignToMeBtnsTemplate" field="btnsColumn"
                                            :width="100" :filterable="false"></kendo-grid-column>
                    </kendo-grid>
                </div>
            </tab>
            <tab id="createdByMeTab" :name="$t('tasks.createdByMe')">
                <div class="col-md-12 py-1" v-if="showCreatedByMeSettings">
                    <i class="fas fa-cogs pointer fa-2x text-success float-right"
                        @click.stop="changeGridSettings('createdByMeGrid')"
                        data-toggle="tooltip"
                        :title="$t('buttons.settings.tooltipText')"></i>
                    <GridUserSettings ref="createdByMeSettings"
                                        :visible="showCreatedByMeSettingsForm"
                                        :grid="$refs['createdByMeGrid']"
                                        :componentName="'createdByMeGrid'">
                    </GridUserSettings>
                    <div style="clear: both;"></div>
                </div>
                <div>
                    <kendo-datasource ref="datasource1"
                        :transport="transportSettings2"
                        :schema-model-id="'id'"
                        :schema-total="'total'"
                        :schema-data="'data'"
                        :page-size="defaultGridRows"
                        :server-paging="true"
                        :server-sorting="true"
                        :server-filtering="true"
                        :change="onChange" />
                    <kendo-grid ref="createdByMeGrid"
                        :data-source-ref="'datasource1'"
                        :editable="gridOptions.editable"
                        :filterable="gridOptions.filterable"
                        :pageable="gridOptions.pageable"
                        :reorderable="gridOptions.reorderable"
                        :resizable="gridOptions.resizable"
                        :groupable="gridOptions.groupable"
                        :allow-copy="gridOptions.allowCopy"
                        :column-menu="gridOptions.columnMenu"
                        :sortable-mode="gridOptions.sortable.mode"
                        :sortable-allow-unsort="gridOptions.sortable.allowUnsort"
                        :sortable-show-indexes="gridOptions.sortable.showIndexes"
                        :selectable="gridOptions.selectable"
                        :scrollable="gridOptions.scrollable"
                        :dataBound="onDatabound">
                        <kendo-grid-column :field="'id'" :title="'Id'" :width="100" :lockable="true"
                                            :locked="false"></kendo-grid-column>
                        <kendo-grid-column :field="'title'" :title="$t('tasks.title')" :width="200"
                                            :lockable="true" :locked="false"></kendo-grid-column>
                        <!-- <kendo-grid-column :field="'createdOn'" :title="$t('tasks.assignedOn')" :width="200" :lockable="true" :locked="false" :format="'{0:dd.MM.yyyy}'"></kendo-grid-column> -->
                        <kendo-grid-column :field="'assigneesAsString'" :title="$t('tasks.assignees')"
                                            :width="200" :lockable="true"
                                            :locked="false"></kendo-grid-column>
                        <kendo-grid-column :field="'deadline'" :title="$t('tasks.deadline')" :width="200"
                                            :lockable="true" :locked="false"
                                            :format="'{0:dd.MM.yyyy H:mm}'"></kendo-grid-column>
                        <kendo-grid-column :field="'type'" :title="$t('tasks.type')" :width="200"
                                            :lockable="true" :locked="false"></kendo-grid-column>
                        <kendo-grid-column :field="'priority'" :title="$t('tasks.priority')" :width="200"
                                            :lockable="true" :locked="false"></kendo-grid-column>
                        <kendo-grid-column :field="'category'" :title="$t('tasks.category')" :width="200"
                                            :lockable="true" :locked="false"></kendo-grid-column>
                        <kendo-grid-column :field="'status'" :title="$t('tasks.status')" :width="150"
                                            :lockable="true" :locked="false"></kendo-grid-column>
                        <kendo-grid-column :template="btnsTemplate" :width="150" field="btnsColumn"
                                            :filterable="false" :title="$t('actions')"></kendo-grid-column>
                    </kendo-grid>
                </div>
            </tab>
        </tabs>
        <CreateSignatureModal @onClose="onModalClose" :task-id="activeTaskId" :show="showCreateSignatureModal" @updated="refresh"></CreateSignatureModal>
        <CreateModal @created="onCreate" :value="createModel" :show="showCreate" @onClose="onModalClose" ref="createModal"></CreateModal>
        <EditModal v-model="editModel" :show="showEdit" @onClose="onEditClose" @updated="onEdit"></EditModal>
        <UpdateModal v-model="updateModel" :show="showUpdate" @onClose="onUpdateClose"
                        @updated="onUpdate"></UpdateModal>
        <DisplayModal :value="displayModel" :show="showDisplay" @onClose="onDisplayClose"></DisplayModal>
        <CompleteModal :value="completeId" :show="showComplete" @onClose="onCompleteClose"
                        @updated="refresh"></CompleteModal>
        <DeclineModal :show.sync="showDecline" :taskId="activeTaskId" :current-assignee="this.assignee"
                        @onClose="onModalClose"
                        @updated="refresh"></DeclineModal>
        <ReturnModal :show.sync="showReturn" :taskId="activeTaskId" @onClose="onModalClose"
                        @updated="refresh"></ReturnModal>
        <RestartModal v-model="restartModel" :show="showRestart" @onClose="onRestartClose"
                        @updated="onRestart"></RestartModal>
        <ExpandModal v-model="expandModel" :show="showExpand" @onClose="onExpandClose"
                        @updated="onExpand"></ExpandModal>
    </div>
</template>

<script>
/* eslint-disable */
import Vue from 'vue';
import CreateModal from '@/components/tasks/create.modal';
import CreateSignatureModal from '@/components/tasks/createSignature.modal';
import EditModal from '@/components/tasks/edit.modal';
import UpdateModal from '@/components/tasks/update.modal';
import DisplayModal from '@/components/tasks/display.modal';
import CompleteModal from '@/components/tasks/complete.modal';
import DeclineModal from '@/components/tasks/decline.modal';
import ReturnModal from '@/components/tasks/return.modal';
import RestartModal from '@/components/tasks/restartDeclined.modal'
import ExpandModal from '@/components/tasks/expandTask.modal'
import NomDropdown from '@/components/dropdown/NomenclatureDropdown';
import { Task } from '@/models/models';
import BtnsTemplate from '@/components/grid/StandardBtnsTemplate';
import taskService from '@/services/tasks.service';
import { mapGetters } from 'vuex';
import GridUserSettings from '@/components/grid/GridSettingsWrapper';
import CustomTabs from '@/components/tab/CustomTabs';

Vue.use(CustomTabs);

export default {
    components: {
        CreateModal,
        CreateSignatureModal,
        EditModal,
        UpdateModal,
        DisplayModal,
        NomDropdown,
        CompleteModal,
        DeclineModal,
        ReturnModal,
        GridUserSettings,
        RestartModal,
        ExpandModal
    },
    data() {
        return {
            showAssignedToMeSettings: false,
            showCreatedByMeSettings: false,
            cteatedByMe: [],
            assignedToMe: [],
            transportSettings: {
                read: {
                    url: this.$store.getters.baseUrl + '/api/tasks/AssignTo',
                    dataType: 'json',
                    type: 'POST',
                    contentType: 'application/json',
                    beforeSend: this.beforeSend
                },
                parameterMap: this.parameterMap
            },
            transportSettings2: {
                read: {
                    url: this.$store.getters.baseUrl + '/api/tasks/AssignBy',
                    dataType: 'json',
                    type: 'POST',
                    contentType: 'application/json',
                    beforeSend: this.beforeSend
                },
                parameterMap: this.parameterMap
            },
            editModel: null,
            showEdit: false,
            showCreate: false,
            showDisplay: false,
            displayModel: null,
            showUpdate: false,
            updateModel: null,
            showComplete: false,
            completeId: null,
            showDecline: false,
            showReturn: false,
            activeTaskId: null,
            createModel: null,
            showRestart: false,
            restartModel: null,
            expandModel: null,
            showExpand: false,
            showAssignedToMeSettingsForm: false,
            showCreatedByMeSettingsForm: false,
            assignee: null,
            schemaModelFields: {
                id: {
                    name: 'id',
                    type: 'number',
                    editable: false,
                    nullable: true,
                    visible: true,
                    titleKey: 'registers.lectors.id'
                },
                title: {
                    name: 'title',
                    type: 'string',
                    editable: false,
                    nullable: false,
                    visible: true,
                    titleKey: 'tasks.title'
                },
                assigner: {
                    name: 'assigner',
                    type: 'string',
                    editable: false,
                    nullable: true,
                    visible: true,
                    titleKey: 'tasks.assigner'
                }
            },
            defaultGridRows: this.$store.getters.defaultGridRows,
            showCreateSignatureModal: false
        };
    },
    methods: {
        onDatabound(e) {
            if (e.sender.options.dataSourceRef == 'datasource2' && !this.showAssignedToMeSettings) {
                this.showAssignedToMeSettings = true;
            } else if (e.sender.options.dataSourceRef == 'datasource1' && !this.showCreatedByMeSettings) {
                this.showCreatedByMeSettings = true;
            }

            var items = e.sender.items();
            items.each(function (idx, item) {
                let dataItem = e.sender.dataItem(item);
                if (dataItem.statusId == 2) {
                    $(item).addClass('left-border-green');
                } else if (dataItem.statusId == 4 || dataItem.statusId == 7) {
                    $(item).addClass('left-border-blue');
                }
            });
        },
        parameterMap: function (options, operation) {
            if (operation !== 'read' && options.models) {
                return { models: kendo.stringify(options.models) };
            } else {
                return kendo.stringify(options);
            }
        },
        onChange(data) {
            //parse date field in the grid data
            data.items.forEach(item => {
                item.deadline = new Date(item.deadline);
                item.createdOn = new Date(item.createdOn);
            });
        },
        beforeSend: function (req) {
            if (this.token) {
                req.setRequestHeader('Authorization', 'Bearer ' + this.token);
            }
        },
        btnsTemplate: function (e) {
            return {
                template: Vue.component(BtnsTemplate.name, BtnsTemplate),
                templateArgs: {
                    ...e,
                    //parentComponent: this.$refs.createdByMeGrid,
                    btns: [
                        {
                            name: 'restart',
                            text: '',
                            tooltip: this.$t('buttons.restart.tooltipText'),
                            class: 'btn btn-success',
                            icon: 'fas fa-edit',
                            show: e.statusId === 5 && this.claims.tasks.update,
                            clickHandler: this.showRestartModal
                        },
                        {
                            name: 'edit',
                            text: '',
                            tooltip: this.$t('buttons.edit.tooltipText'),
                            class: 'btn btn-success',
                            icon: 'fas fa-edit',
                            show: e.statusId < 4 && this.claims.tasks.update,
                            clickHandler: this.showEditModal
                        },
                        {
                            name: 'details',
                            text: '',
                            tooltip: this.$t('buttons.details.tooltipText'),
                            class: 'btn btn-info',
                            icon: 'fas fa-eye',
                            show: this.claims.tasks.read,
                            clickHandler: this.showDetailsModal
                        },
                        {
                            name: 'delete',
                            text: '',
                            tooltip: this.$t('buttons.delete.tooltipText'),
                            class: 'btn btn-danger',
                            icon: 'fas fa-trash',
                            show: e.statusId === 2 && this.claims.tasks.delete,
                            clickHandler: this.onDeleteTask
                        },
                        {
                            name: 'startSigningTask',
                            text: '',
                            tooltip: this.$t('tasks.createNewSingingTask'),
                            class: 'btn btn-success',
                            icon: 'fas fa-file-signature',
                            show: e.statusId === 7,
                            clickHandler: this.onCreateNewSingingTask
                        },
                        {
                            name: 'confirm',
                            text: '',
                            tooltip: this.$t('tasks.done_v'),
                            class: 'btn btn-danger',
                            icon: 'fas fa-check-double',
                            show: e.statusId === 4 && this.claims.tasks.update,
                            clickHandler: this.onDone
                        },
                        {
                            name: 'return',
                            text: '',
                            tooltip: this.$t('tasks.return'),
                            class: 'btn btn-danger',
                            icon: 'fas fa-undo',
                            show: e.statusId === 4 && this.claims.tasks.update,
                            clickHandler: this.showReturnModal
                        },
                        {
                            name: 'archive',
                            text: '',
                            tooltip: this.$t('tasks.archive_v'),
                            class: 'btn btn-danger',
                            icon: 'fas fa-archive',
                            show: (e.statusId === 5 || e.statusId === 7) && this.claims.tasks.update,
                            clickHandler: this.onArchiveTask
                        },
                        {
                            name: 'copy',
                            text: '',
                            tooltip: this.$t('tasks.copy'),
                            class: 'btn btn-info',
                            icon: 'fas fa-copy',
                            show: true,
                            clickHandler: this.copyTask
                        }
                    ]
                }
            };
        },
        assignToMeBtnsTemplate: function (e) {
            return {
                template: Vue.component(BtnsTemplate.name, BtnsTemplate),
                templateArgs: {
                    ...e,
                    //parentComponent: this.$refs.createdByMeGrid,
                    btns: [
                        {
                            name: 'details',
                            text: '',
                            tooltip: this.$t('buttons.details.tooltipText'),
                            class: 'btn btn-info',
                            icon: 'fas fa-eye',
                            show: this.claims.tasks.read,
                            clickHandler: this.showDetailsModal
                        },
                        {
                            name: 'addExecutor',
                            text: '',
                            tooltip: this.$t('tasks.addExecutor'),
                            class: 'btn btn-success',
                            icon: 'fas fa-plus',
                            show: (e.statusId === 2 || e.statusId === 3) && this.claims.tasks.update,
                            clickHandler: this.showExpandModal
                        },
                        {
                            name: 'start',
                            text: '',
                            tooltip: this.$t('tasks.startTask'),
                            class: 'btn btn-success',
                            icon: 'fas fa-play',
                            show: (e.statusId === 2 || e.statusId === 8) && this.claims.tasks.update,
                            clickHandler: this.onStartTask
                        },
                        {
                            name: 'decline',
                            text: '',
                            tooltip: this.$t('tasks.decline'),
                            class: 'btn btn-success',
                            icon: 'fas fa-times-circle',
                            show: e.statusId === 2 && this.claims.tasks.update,
                            clickHandler: this.showDeclineModal
                        },
                        {
                            name: 'complete',
                            text: '',
                            tooltip: this.$t('tasks.completeTask'),
                            class: 'btn btn-success',
                            icon: 'fas fa-check',
                            show: e.statusId === 3 && this.claims.tasks.update,
                            clickHandler: this.onCompleteTask
                        },
                        {
                            name: 'copy',
                            text: '',
                            tooltip: this.$t('tasks.copy'),
                            class: 'btn btn-info',
                            icon: 'fas fa-copy',
                            show: true,
                            clickHandler: this.copyTask
                        }
                    ]
                }
            };
        },
        changeGridSettings(gridName) {
            if (gridName === 'createdByMeGrid') {
                this.showCreatedByMeSettingsForm = !this.showCreatedByMeSettingsForm;
            } else {
                this.showAssignedToMeSettingsForm = !this.showAssignedToMeSettingsForm;
            }
        },
        showDetailsModal(e) {
            this.displayModel = {...e};
            this.showDisplay = true;
        },
        showEditModal(e) {
            this.editModel = {...e};
            this.showEdit = true;
        },
        showUpdateModal(e) {
            this.updateModel = {...e};
            this.showUpdate = true;
        },
        showRestartModal(e) {
            this.restartModel = {...e};
            this.showRestart = true
        },
        showDeclineModal(args) {
            this.activeTaskId = args.id;
            this.assignee = args.assignees.find(a => a.userId === this.$store.getters.userId)
            this.showDecline = true;
        },
        showReturnModal(e) {
            this.activeTaskId = e.id;
            this.showReturn = true;
        },
        showExpandModal(e) {
            this.expandModel = {...e};
            this.showExpand = true
        },
        onEditClose() {
            this.showEdit = false;
            this.editModel = null;
        },
        onRestartClose() {
            this.showRestart = false;
            this.restartModel = null;
        },
        onUpdateClose() {
            this.showUpdate = false;
            this.updateModel = null;
        },
        onDisplayClose() {
            this.showDisplay = false;
            this.displayModel = null;
        },
        onCompleteClose() {
            this.completeId = null;
            this.showComplete = false;
            this.refresh();
        },
        onExpandClose() {
            this.showExpand = false;
            this.expandModel = null;
        },
        onUpdate(item) {
            this.refresh();
        },
        onEdit(item) {
            this.refresh();
        },
        onRestart(item) {
            this.refresh();
        },
        onExpand(item) {
            this.refresh();
        },
        onCreate(item) {
            this.refresh();
        },
        onDeleteTask(e) {
            this.deleteId = e.id;
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: this.$t('tasks.deletion'),
                text: this.$t('tasks.deletionConfirmMessage'),
                accept: this.deleteTask,
                acceptText: this.$t('buttons.ok'),
                cancelText: this.$t('buttons.cancel'),
                cancel: () => (this.deleteId = null)
            });
        },
        onStartTask(e) {
            this.startId = e.id;
            this.$vs.dialog({
                type: 'confirm',
                color: 'success',
                title: this.$t('tasks.taskStart'),
                text: this.$t('tasks.taskStartMessage'),
                accept: this.startTask,
                acceptText: this.$t('buttons.ok'),
                cancelText: this.$t('buttons.cancel'),
                cancel: () => (this.startId = null)
            });
        },
        onArchiveTask(e) {
            this.startId = e.id;
            this.$vs.dialog({
                type: 'confirm',
                color: 'success',
                title: this.$t('tasks.archive'),
                text: this.$t('tasks.archiveMessage'),
                accept: this.arhiveTask,
                acceptText: this.$t('buttons.ok'),
                cancelText: this.$t('buttons.cancel'),
                cancel: () => (this.startId = null)
            });
        },
        onCreateNewSingingTask(e) {
            this.activeTaskId = e.id;
            $('#createSigningFromTaskModal').modal('show');
            this.showCreateSignatureModal = true;
        },
        onCompleteTask(e) {
            this.completeId = e.id;
            this.showComplete = true;
        },
        onDone(e) {
            this.doneId = e.id;
            this.$vs.dialog({
                type: 'confirm',
                color: 'success',
                title: this.$t('tasks.done_v'),
                text: this.$t('tasks.doneConfirm'),
                accept: this.setTaskToDone,
                acceptText: this.$t('buttons.ok'),
                cancelText: this.$t('buttons.cancel'),
                cancel: () => (this.doneId = null)
            });
        },
        onModalClose() {
            this.activeTaskId = null;
            this.createModel = null;
            this.showCreate = false;
            this.showCreateSignatureModal = false;
        },
        setTaskToDone() {
            taskService
                .confirm(this.doneId)
                .then(() => {
                    this.$vs.notify({
                        color: 'success',
                        title: this.$t('updateSuccess'),
                        text: ''
                    });
                    this.refresh();
                })
                .catch(err =>
                    this.$vs.notify({
                        color: 'danger',
                        title: this.$t('notifications.error'),
                        text: this.$helpers.errorText(err)
                    })
                )
                .then(() => (this.startId = null));
        },
        deleteTask() {
            taskService
                .delete(this.deleteId)
                .then(() => {
                    this.$vs.notify({
                        color: 'success',
                        title: this.$t('deleteSuccess'),
                        text: ''
                    });
                    this.refresh();
                })
                .catch(err =>
                    this.$vs.notify({
                        color: 'danger',
                        title: this.$t('notifications.error'),
                        text: this.$t('notifications.serverError')
                    })
                )
                .then(() => (this.deleteId = null));
        },
        startTask() {
            taskService
                .start(this.startId)
                .then(() => {
                    this.$vs.notify({
                        color: 'success',
                        title: this.$t('updateSuccess'),
                        text: ''
                    });
                    this.refresh();
                })
                .catch(err =>
                    this.$vs.notify({
                        color: 'danger',
                        title: this.$t('notifications.error'),
                        text: this.$helpers.errorText(err)
                    })
                )
                .then(() => (this.startId = null));
        },
        arhiveTask() {
            taskService
                .archive(this.startId)
                .then(() => {
                    this.$vs.notify({
                        color: 'success',
                        title: this.$t('updateSuccess'),
                        text: ''
                    });
                    this.refresh();
                })
                .catch(err =>
                    this.$vs.notify({
                        color: 'danger',
                        title: this.$t('notifications.error'),
                        text: this.$helpers.errorText(err)
                    })
                )
                .then(() => (this.startId = null));
        },
        refresh(gridName) {
            if (gridName) {
                this.$refs[gridName].kendoWidget().dataSource.read();
            } else {
                this.$refs['createdByMeGrid'].kendoWidget().dataSource.read();
                this.$refs['assignedToMeGrid'].kendoWidget().dataSource.read();
            }
        },
        showTask(taskId) {
            this.$http
                .get('/api/tasks/' + taskId)
                .then(response => {
                    this.showDetailsModal(response.data);
                })
                .catch(err => {
                    this.$vs.notify({
                        color: 'danger',
                        title: this.$t('notifications.error'),
                        text: this.$helpers.errorText(err)
                    });
                });
        },
        copyTask(e) {
            let task = new Task(e);
            this.createModel = task;

            $(this.$refs.createModal.$el).modal('show');
        }
    },
    computed: {
        ...mapGetters(['claims', 'gridOptions']),
        token: function () {
            return this.$store.getters.authToken;
        }
    },
    mounted() {
        var taskId = this.$route.query['view'];

        if (taskId) {
            this.showTask(taskId.trim());
        }
    }
};
</script>

<style lang="scss">
.grid-wrapper {
    overflow-x: auto;
}

.vs-dialog footer {
    padding: 5px;

    .vs-button-filled {
        padding: 5px;
        margin-right: 10px;
    }

}

tr.left-border-danger {
    &:hover {
        color: rgba(255, 0, 0, 0.7) !important;
    }

    td:first-child {
        border-left: 3px solid rgba(255, 0, 0, 0.5) !important;
    }

}

tr.left-border-blue {
    &:hover {
        color: #3498db !important;
    }

    td:first-child {
        border-left: 3px solid #3498db !important;
    }

}

tr.left-border-green {
    &:hover {
        color: #4caf50 !important;
    }

    td:first-child {
        border-left: 3px solid #4caf50 !important;
    }
}
</style>
